import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService {
    private _isMaintenanceMode = new BehaviorSubject<boolean>(false);

    get isMaintenanceMode$(): Observable<boolean> {
        return this._isMaintenanceMode.asObservable();
    }

    get isMaintenanceMode(): boolean {
        return this._isMaintenanceMode.value;
    }

    showMaintenanceModal(): void {
        if (!this._isMaintenanceMode.value) {
            this._isMaintenanceMode.next(true);
        }
    }

    hideMaintenanceModal(): void {
        this._isMaintenanceMode.next(false);
    }
}
